import L from 'leaflet';
import { computed, ref } from 'vue';
import { MAX_TIME, mouseHoveredDevice, selectedGeoFence, state } from './SearchDevice';
import { measuringLocations, measuringTarget } from './DistanceMeasuring';
import { deviceCustomMarker } from './ImageUtility';
import { showDeviceSimple } from './ModalUtility';
import { handleMarkerContextMenu, handleMarkersClickMenu, handleMarkersContextMenu } from './MenuUtility';
import { detectCustomMarkerUnderMouse, detectMarkerUnderMouse, detectPolygonsUnderMouse, hideTooltip } from './MouseHover';
import { hoveredDeviceID } from './SortUtility';
import { GET_SERVER_REQUEST, imageUrl, SERVER_REQUEST } from './ServerConnect';
import { loadingStore } from './LoadingStore';
import { Company_Name, Get_Setting } from './Setting';
import { nbLastUpdateTime, cpeLastUpdateTime, SendErrorLog } from './GlobalUtility';

export const mapSwitcher = ref(true);
const mapList = [
  {
    name: 'dev1',
    url: 'http://qls.peratech.co.kr/tiles/data/tilemap/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.qubicom.co.kr/">Qubicom</a> contributors',
  },
  {
    name: 'dev2',
    url: 'http://qls.peratech.co.kr/un/data/tilemap/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.qubicom.co.kr/">Qubicom</a> contributors',
  },
  {
    name: 'online',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
  {
    name: 'open',
    url: '/tiles/data/tilemap/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.qubicom.co.kr/">Qubicom</a> contributors',
  },
  {
    name: 'un',
    url: '/un/data/tilemap/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.qubicom.co.kr/">Qubicom</a> contributors',
  }
];

export const selectMap = (name) => {
  return mapList.find(m => m.name === name).url;
};
export const selectAttribution = (name) => {
  return mapList.find(m => m.name === name).url;
};
const createNewMapLayer = (name) => {
  const url = selectMap(name);
  const attribution = selectAttribution(name);

  return L.tileLayer(url, {
    minZoom: 0,
    maxZoom: 18,
    attribution: attribution,
  });
};
const firstMap = process.env.NODE_ENV === 'development' ? 'dev1' : 'open';
const secondMap = process.env.NODE_ENV === 'development' ? 'dev2' : 'un';
// const secondMap = 'online'

export const Set_Default_Map_Setting = async () => {
  const loc = Get_Setting('map_default_location');
  latitude.value = loc.latitude;
  longitude.value = loc.longitude;
  if (Company_Name.value === "Simsys_Real") {
    latitude.value = 6.189;
    longitude.value = 31.606;
  }
  defaultLocation.value = [latitude.value, longitude.value];
}

const latitude = ref(37.3757);
const longitude = ref(127.1113);

// watch([latitude, longitude], defaultLocation.value = [latitude.value, longitude.value])
export const defaultLocation = ref([latitude.value, longitude.value]);
export const defaultZoomLevel = ref(16);

export const polygonLayer = ref([]);

//#region 마커 그룹화 간격 관련
// 기존에 저장된 값 불러오기 (없으면 기본값 10)
export const resetMarkerGroupingRange = () => {
  savedDistance.value = Get_Setting('marker_grouping_range');
}
const savedDistance = ref(10);
export const getMarkerGroupingRange = () => {
  return savedDistance.value
}
export const deviceGroupRange = ref(getMarkerGroupingRange());  // 그룹화 대상 거리 지정 (18줌 = 15m 그 외 줌 아웃 시 2의 배수로 커짐)
//#endregion

export async function firstMapSetting(elementName = 'map', zoomLevel = defaultZoomLevel.value) {
  const map = L.map(elementName, { zoomAnimation: false, 'attributionControl': false})
              .setView(defaultLocation.value, zoomLevel)
              .addLayer(createNewMapLayer(mapSwitcher.value ? firstMap : secondMap));
  map.zoomControl.remove();

  const baseLayers = {
    "OSM": createNewMapLayer(firstMap),
    "UN": createNewMapLayer(secondMap)
  }
  L.control.layers(baseLayers, null, {
    position: 'bottomright'
  }).addTo(map);
  return map;
}

export function numberAndCloseMarker(index) {
    const markerHtml = `
      <div style="position: relative;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 30px;
                  height: 30px;
                  background-color: red;
                  border-radius: 50%;
                  color: white;">
        ${index}
        <button style="position: absolute;
                       top: -10px;
                       right: -10px;
                       width: 20px;
                       height: 20px;
                       border: none;
                       background: none;
                       color: black;
                       font-weight: bold;
                       cursor: pointer;">
            ×
        </button>
      </div>
    `;

    const customIcon = L.divIcon({
        className: 'custom-pin',
        html: markerHtml,
        iconSize: [30, 30], // 핀 크기 설정
        iconAnchor: [15, 30], // 핀의 중앙을 기준으로 위치 설정
    })

    return customIcon;
}

export const startColor = [0, 123, 255, 1];    // 파란색 (출발점)
export const endColor = [255, 99, 132, 1];     // 빨간색 (도착점)

export function drawMarkerGradient(totalMarkers, index) {
    const ratio = index / (totalMarkers - 1); // 0~1 비율 계산

    // 각 RGBA 채널별로 중간값을 계산
    const r = Math.round(startColor[0] * (1 - ratio) + endColor[0] * ratio);
    const g = Math.round(startColor[1] * (1 - ratio) + endColor[1] * ratio);
    const b = Math.round(startColor[2] * (1 - ratio) + endColor[2] * ratio);
    const a = startColor[3] * (1 - ratio) + endColor[3] * ratio // 알파 채널

    return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export const CalculateCircleBoundary = (lat, lng, distance = 10) => {
  // 반경을 이용해 남서(NW), 북동(SE) 좌표 계산
  const southWest = L.latLng(
    lat - (distance / 111320), // 1m ≈ 1/111320도 (위도 기준)
    lng - (distance / (40075000 * Math.cos(lat * (Math.PI / 180))) / 360) // 경도 보정
  );

  const northEast = L.latLng(
    lat + (distance / 111320),
    lng + (distance / (40075000 * Math.cos(lat * (Math.PI / 180))) / 360)
  );

  // 경계 박스 생성 후 fitBounds 적용
  return L.latLngBounds(southWest, northEast);
}

// 마커 업데이트
export const updateMarkers = () => {
  if (!state.map) {
    return;
  }

  if (Array.isArray(state.locations)) {
    state.groupMarkers.forEach(group => group.marker.options.pulseCircle ? state.map.removeLayer(group.marker.options.pulseCircle) : null);
    // 기존 마커 제거
    state.markers.forEach(marker => state.map.removeLayer(marker));
    state.markers = [];
    state.groupMarkers = [];

    // 가장 최근 위치들만 마커로 표시
    state.locations.forEach(item => {
      const { device_id, latitude, longitude, timestamp, speed } = item; // locations에 저장된 값들을 풀어서 가져옴

      let parsedLatitude = parseFloat(latitude);
      let parsedLongitude = parseFloat(longitude);
      if (!Number.isFinite(parsedLatitude) || !Number.isFinite(parsedLongitude)) {
        console.warn(
          `유효하지 않은 좌표를 가진 장치 데이터를 건너뜁니다: Device ID - ${device_id}, Latitude: ${latitude}, Longitude: ${longitude}`
        );
        return;
      }

      if (measuringTarget.value && measuringTarget.value === device_id) measuringLocations.value[0] = L.latLng(latitude, longitude);

      // 장치의 마지막 업데이트 시간 확인
      const now = new Date() - (timestamp ? new Date(timestamp) : "2021-03-08 09:00:00");
      const calTime = Math.floor((now) / 1000);
      const isSoOld = calTime >= MAX_TIME.value // 연결시간이 오래된 단말
      let isHovered = (mouseHoveredDevice.value === device_id); // 마우스 호버상태인 단말

      let foundGroup = false; // 마커 묶음 없는걸로 시작
      for (const group of state.groupMarkers) { // 전체 마커 묶음을 하나하나 펼쳐서 비교
        if (group.marker.getLatLng().distanceTo(L.latLng(latitude, longitude)) <= deviceGroupRange.value
            && group.isDisalbed === isSoOld
            // && group.groupId === item.group_id
            && (isSoOld || ((group.isGetSpeed && speed > 0) || (!group.isGetSpeed && speed <= 0)))) { // 묶음으로 포함된 마커에 그룹화 거리 이내일 경우 신규추가 x 묶어버림
          group.count++;
          group.devices.push({ item });
          if (group.devices.find(device => device.item.device_id === mouseHoveredDevice.value)) isHovered = true;

          // 평균속도 구하기
          const totalSpeed = group.devices.reduce((sum, device) => sum + parseFloat(device.item.speed), 0);

          updateMarkerCount(group, isSoOld, isHovered, (totalSpeed/group.devices.length).toFixed(2));

          if (isHovered) {
            group.marker.options.zIndexOffset = 1300;
          } else if (!isSoOld && group.isGetSpeed) {
            group.marker.options.zIndexOffset = 1200;
          } else if (!isSoOld) {
            group.marker.options.zIndexOffset = 1100;
          }

          foundGroup = true;
          state.markers.push(group.marker);
          break;
        }
      }
      if (!foundGroup) {  // 마커 묶음에 해당되지 않을경우 새로운 마커 생성 및 그룹에 추가
        const setGroupImage = new URL("@/assets/images/simsys/pin_mobile.svg", import.meta.url).href

        const marker = L.marker([latitude, longitude], { icon: isSoOld ? deviceCustomMarker.createIcon_GrayScale(isHovered, 0, setGroupImage) : deviceCustomMarker.createIcon(isHovered, speed, setGroupImage),
                                                        zIndexOffset: isHovered ? 1300 : (isSoOld ? -1000 : (speed > 0 ? 1200 : 1100)),
                                                        pulseCircle: null })
        .on('click', () => {
          showDeviceSimple(item);
        })
        .on('contextmenu', (e) => {
          e.originalEvent.stopPropagation();
          handleMarkerContextMenu(e.originalEvent, item)
        })
        .on('mouseover', (e) => onMarkerHover([item], e))
        .on('mouseout', () => onMarkerHoverOut([device_id]))
        .addTo(state.map);

        // 원래 zIndex 저장
        marker.originalZIndex = marker.options.zIndexOffset;

        state.markers.push(marker);

        state.groupMarkers.push({
          marker: marker,
          count: 1,
          isDisalbed: isSoOld,
          devices: [{ item }],
          isGetSpeed: speed ? speed > 0 : false,
          // groupId: item.group_id,
          groupImage: setGroupImage,
        });
      }
    });
  } else {
    console.error('state.locations is not an array or is undefined');
  }
};

// 마커 중첩 카운트 및 기능(좌/우 클릭 등) 재설정
const updateMarkerCount = (group, isSoOld, selected, speed = 0) => {
  const style = (selected ? 'selected-' : '') + (isSoOld ? 'grayscale' : 'origin');
  const markerHtml = `
    <div style="position: relative;">
      <div class="${style}-marker">
        <img src="${new URL("@/assets/images/simsys/pin_mobile.svg", import.meta.url).href}" style="width: 40px; height: 40px;" />
      </div>
      <span style="position: absolute; top: -15px; right: -15px; 
                    background: ${isSoOld ? 'gray' : 'red'};
                    color: white; 
                    border-radius: 50%;
                    padding: 3px 8px; 
                    font-size: 12px;">
        ${group.count}
      </span>
      ${(speed > 0 && !isSoOld) ? '<span style="position: absolute; bottom: -17px; right: 0; left: 0; background: white; color: black; border-radius: 10px; padding: 1px 2px; font-size: 11px;">' + Math.round(speed) + '</span>' : ''}
    </div>
  `;

  group.marker.setIcon(
    L.divIcon({
      className: "marker-cluster-count",
      html: markerHtml,
      iconSize: [40, 40],
    })
  )
  .off('click')
  .off('contextmenu')
  .off('mouseover')
  .off('mouseout')
  .on('click', (e) => {
    e.originalEvent.stopPropagation();
    handleMarkersClickMenu(e.originalEvent, group)
  })
  .on('contextmenu', (e) => {
    e.originalEvent.stopPropagation();
    handleMarkersContextMenu(e.originalEvent, group)
  })
  .on('mouseover', (e) => onMarkerHover(group.devices.map(device => device.item), e))
  .on('mouseout', () => onMarkerHoverOut(group.devices.map(device => device.item.device_id)));
};

// 폴리곤 생성 함수
export const drawPolygon = (data) => {
  if (!state.map || !data) return;
  const latlngs = data.data.locations;
  let newPolygon;
  if (!latlngs) return;
  if (latlngs.length > 2) newPolygon = L.polygon(latlngs, { color: 'blue', type: "polygon", name: data.geofence_name, data: data });  // 3개 이상의 마커가 있을 때만 폴리곤을 그림
  if (latlngs.length === 1) newPolygon = L.circle(latlngs[0], { radius: data.data.type.includes('#') ? parseFloat(data.data.type.split('#')[1]) : 100, color: 'blue', fillOpacity: 0.2, type: "polygon", name: data.geofence_name, data: data }); // 1개 일경우 원
  polygonLayer.value.push(newPolygon.on("mousemove", (e) => detectPolygonsUnderMouse(e, state.map, polygonLayer))
                                    .on("mouseout", hideTooltip)
                                    .addTo(state.map));
};

export const highlightMarker = (device_id) => {
  if (mouseHoveredDevice.value) resetMarkerHighlight(mouseHoveredDevice.value);
  mouseHoveredDevice.value = device_id;

  const marker = findMarkerByDeviceId(device_id)?.marker;
  if (!marker) return;
  highlightListItem(device_id, true);

  // zIndex 높여 마커 앞으로
  marker.setZIndexOffset(1300);

  setNewIcon(marker, true);
};
export const resetMarkerHighlight = (device_id) => {
  if (!device_id) return;
  mouseHoveredDevice.value = null;

  const marker = findMarkerByDeviceId(device_id)?.marker;
  if (!marker) return;
  highlightListItem(device_id, false);
  
  // 원래 zIndex 복원
  marker.setZIndexOffset(marker.originalZIndex ?? -1000);

  setNewIcon(marker, false);
  // marker.options.icon.html = changeIconClass(marker.options.icon.options.html, false);
};
const findMarkerByDeviceId = (device_id) => {
  const marker = state.groupMarkers.find((group) => group.devices.find((item) => item.item.device_id === device_id))
  if (marker) return marker;
  return null;
};
const setNewIcon = (marker, selected) => {
  const markerOptions = marker.options.icon.options
  const newIcon = L.divIcon({
    className: markerOptions.className,
    html: changeIconHtml(markerOptions.html, selected),
    iconSize: markerOptions.iconSize,
  })
  marker.setIcon(newIcon);
}
const changeIconHtml = (html, selected) => {
  if (selected) {
    return html.replaceAll("origin-marker", "selected-origin-marker").replaceAll("grayscale-marker", "selected-grayscale-marker");
  } else {
    return html.replaceAll("selected-origin-marker", "origin-marker").replaceAll("selected-grayscale-marker", "grayscale-marker");
  }
}

// 마우스를 올렸을 때 리스트 아이템에 스타일을 추가
const onMarkerHover = (devices, event) => {
  if (!devices) return;
  devices.forEach(device => {
    // 리스트 최상단으로 올리기 위해 별도 리스트에 추가
    hoveredDeviceID.value.add(device.device_id);
  });
  hoveredDeviceID.value.forEach(device => highlightListItem(device, true));

  // 마우스 호버 시 장치 이름 보이게
  detectMarkerUnderMouse(event, devices);
}

// 마우스를 뗐을 때 리스트 아이템의 스타일을 원래대로 복원
const onMarkerHoverOut = (device_id) => {
  if (!device_id) return;

  hoveredDeviceID.value.forEach(device => highlightListItem(device, false));
  hoveredDeviceID.value.clear();

  // 마우스 호버 해제 시 장치 이름 안보이게
  hideTooltip();
}

// 리스트 아이템을 하이라이트하는 함수
const highlightListItem = (device_id, highlight) => {
  const listItem = document.querySelector(`#device-${device_id}`);
  if (listItem) {
    listItem.style.background = highlight ? '#C5C9CC' : '#FFFFFF';
    listItem.style.borderLeft = highlight ? '3px solid #97D4FF' : 'none';
    listItem.style.paddingLeft = highlight ? '4px' : '7px';
  }
};





//#region 사용자 추가 마커
export const isPOIModalSimpleOpen = ref(false);
export const isPOIModalSimpleOpen2 = ref(false);
export const selectedCustomMarker = ref();
const customMarkerList = ref([]);
const customMarkers = ref([]);
export const fetchCustomMarker = async () => {
  customMarkers.value?.forEach(customMarker => state.map.removeLayer(customMarker));
  customMarkers.value = [];
  customMarkerList.value = await GET_SERVER_REQUEST('marker');
  if (selectedCustomMarker.value) selectedCustomMarker.value = customMarkerList.value?.find(cm => cm.marker_id === selectedCustomMarker.value.marker_id);
  
  if (customMarkerList.value) {
    customMarkerList.value?.filter(marker => !marker.is_deleted)?.forEach(marker => {
      customMarkers.value.push(L.marker([marker.latitude, marker.longitude], {icon: createCustomMarkerIcon(marker.marker_image)})
      .on('click', () => {})
      .bindPopup(`
        <div class="popup-content">
          <h3>마커 정보</h3>
          <div class="popup-item"><b>마커 이름:</b> ${marker.title}</div>
          <div class="popup-item"><b>마커 설명:</b> ${marker.description}</div>
          <div class="popup-item"><b>위도(Latitude):</b> ${marker.latitude}</div>
          <div class="popup-item"><b>경도(Longitude):</b> ${marker.longitude}</div>
          <div class="popup-item"><b>생성일:</b> ${marker.created_at}</div>
          <div class="popup-item"><b>수정일:</b> ${marker.modified_at}</div>
          <div class="popup-item">
            <img src="${marker.marker_image ? (imageUrl() + marker.marker_image) : new URL('../assets/images/logo.png', import.meta.url).href}" />
          </div>
          <div style="display: flex; justify-content: space-between;">
            <button class="edit-button" id="edit-${marker.marker_id}">Edit</button>
            <button class="delete-button" id="delete-${marker.marker_id}">Delete</button>
          </div>
        </div>
      `)
      .on('popupopen', () => {
        const button_edit = document.getElementById(`edit-${marker.marker_id}`);
        if (button_edit) {
          button_edit.addEventListener('click', () => editCustomMarker(marker));
        }

        const button_delete = document.getElementById(`delete-${marker.marker_id}`);
        if (button_delete) {
          button_delete.addEventListener('click', () => deleteCustomMarker(marker));
        }
      })
      .on('popupclose', () => {
        const button_edit = document.getElementById(`edit-${marker.marker_id}`);
        if (button_edit) {
          button_edit.removeEventListener('click', () => editCustomMarker(marker));
        }

        const button_delete = document.getElementById(`delete-${marker.marker_id}`);
        if (button_delete) {
          button_delete.addEventListener('click', () => deleteCustomMarker(marker));
        }
      })
      .on('mouseover', (e) => detectCustomMarkerUnderMouse(e, customMarkerToolTimeText(marker)))
      .on('mouseout', () => hideTooltip())
      .addTo(state.map));
    });
  }
  
  
// .on('click', () => {
// showDeviceSimple(item);
// })
// .on('contextmenu', (e) => {
// e.originalEvent.stopPropagation();
// handleMarkerContextMenu(e.originalEvent, item)
// })
// .on('mouseover', (e) => onMarkerHover([item], e))
// .on('mouseout', () => onMarkerHoverOut([device_id]))

};
export const createCustomMarkerIcon = (image) => {
  return L.divIcon({
    html: `<div class="origin-marker">
              <img src="${image ? (imageUrl() + image) : new URL('../assets/images/logo.png', import.meta.url).href}" style="width: 40px; height: 40px; border-radius: 50%; border: 1px solid gray;" />
            </div>`,
    iconSize: [40, 40],
    className: '', // 기본 스타일 제거
  });
};
const editCustomMarker = (marker) => {
  selectedCustomMarker.value = marker;
  isPOIModalSimpleOpen.value = true;
};
export const deleteCustomMarker = async (marker) => {
  const totalData = {
    marker_id: marker.marker_id
  }
  const jsonData = JSON.stringify(totalData);

  loadingStore.showLoading();
  const response = await SERVER_REQUEST('marker', 'DELETE', jsonData);

  if (response.message) {
    // SendErrorLog('Marker', { 
    //   name: 'Delete success',
    //   message: marker.title,
    //   stack: `Deleted marker : ${marker.title}`,
    // });
  } else {
    SendErrorLog(`Delete-Marker(${marker.title})`, response);
  }
  
  fetchCustomMarker();
  loadingStore.hideLoading();
};
export const isAddCustomMarker = ref(false);
export const newCustomMarkerLatLng = ref();
export const addCustomMarker = (e = null) => {
  if (!e) {
    isPOIModalSimpleOpen2.value = true;
    newCustomMarkerLatLng.value = { lat: defaultLocation.value[0], lng: defaultLocation.value[1] };
  }
  else {
    isPOIModalSimpleOpen.value = true;
    newCustomMarkerLatLng.value = e.latlng;
  }
  isAddCustomMarker.value = true;
  
};
const customMarkerToolTimeText = (cm) => {
  const text = `${cm.title}\n(${cm.description})`;
  return text
};
//#endregion

//#region 기지국 마커
export const baseStationList = ref(null);
export const baseStationMarkers = ref([]);
export const nbUEList = ref([]);
export const cpeList = ref([]);
export const CPEMarkers = ref([]);
export const searchQueryNB = ref("");
export const filteredNB = computed(() => {
  const searchedList = baseStationList.value?.filter(nb =>
    String(nb.nb_id).toLowerCase().includes(searchQueryNB.value.toLowerCase())
    || String(nb.latest_lan_info?.ip_address).toLowerCase().includes(searchQueryNB.value.toLowerCase())
  )
  return searchedList?.sort((a, b) => {
    if (mouseHoveredNBMarker.value) {
      // 1️⃣ 호버 중인 nb_id를 먼저 정렬
      const aHovered = mouseHoveredNBMarker.value === a.nb_id;
      const bHovered = mouseHoveredNBMarker.value === b.nb_id;
      if (aHovered !== bHovered) return bHovered - aHovered; // true > false 순으로 정렬
      else return 0;
    } else {
      const aTime = nbLastUpdateTime(a);
      const bTime = nbLastUpdateTime(b);
      if (aTime !== bTime) return aTime - bTime;  // 최신 업데이트 순으로 정렬
      else return 0;
    }
  })
})
export const filteredCPE = computed(() => {
  const searchedList = cpeList.value?.filter(ue => ue.latitude && ue.longitude).filter(ue => 
    String(ue.imsi).toLowerCase().includes(searchQueryNB.value.toLowerCase())
    || String(ue.msisdn).toLowerCase().includes(searchQueryNB.value.toLowerCase())
    || String(ue.nb_ip).toLowerCase().includes(searchQueryNB.value.toLowerCase())
  )
  return searchedList?.sort((a, b) => {
    if (mouseHoveredCPEMarker.value) {
      // 1️⃣ 호버 중인 nb_id를 먼저 정렬
      const aHovered = mouseHoveredCPEMarker.value === a.imsi;
      const bHovered = mouseHoveredCPEMarker.value === b.imsi;
      if (aHovered !== bHovered) return bHovered - aHovered; // true > false 순으로 정렬
      else return 0;
    } else {
      const aTime = cpeLastUpdateTime(a);
      const bTime = cpeLastUpdateTime(b);
      if (aTime !== bTime) return aTime - bTime;  // 최신 업데이트 순으로 정렬
      else return 0;
    }
  })
})

export const setBaseStationMarker = (data) => {
  if (!data) return;
  baseStationMarkers.value?.forEach(bsMarker => state.map.removeLayer(bsMarker.marker));
  baseStationMarkers.value = [];
  CPEMarkers.value?.forEach(ueMarker => state.map.removeLayer(ueMarker.marker));
  CPEMarkers.value = [];

  // 데이터 전부 있는 기지국만 가지고 있기
  baseStationList.value = data.nb?.filter(nb => nb.latest_lan_info && nb.latest_gps_info && nb.latest_service_state_info && nb.latest_service_state_info.epc_state);
  if (baseStationMarkers.value) {
    filteredNB.value?.forEach(marker => {
      const lanInfo = marker.latest_lan_info;
      const gpsInfo = marker.latest_gps_info;
      const stateInfo = marker.latest_service_state_info;
      const epcState = marker.latest_service_state_info.epc_state;
      
      const iconType = stateInfo.bb_state === "INS" && stateInfo.CELL1_STATE === "INS" && stateInfo.epc_state !== "OFF";

      const newMarker = L.marker([gpsInfo.latitude, gpsInfo.longitude], { iconType: iconType })
      .on('click', () => {})
      // .bindPopup(`
      //   <div class="popup-content">
      //     <h3>기지국 정보 (${stateInfo.nb})</h3>
      //     <div class="popup-item"><b>IP Address:</b> ${lanInfo.ip_address}</div>
      //     <div class="popup-item"><b>NB ID:</b> ${marker.nb_id}</div>
      //     <div class="popup-item"><b>위도(Latitude):</b> ${gpsInfo.latitude}</div>
      //     <div class="popup-item"><b>경도(Longitude):</b> ${gpsInfo.longitude}</div>
      //     <div class="popup-item"><b>BB State:</b> ${stateInfo.bb_state}</div>
      //     <div class="popup-item"><b>Cell State:</b> ${stateInfo.CELL1_STATE}</div>
      //   </div>
      // `)
      .on('mouseover', (e) => {detectCustomMarkerUnderMouse(e, 
`${stateInfo.nb}
${lanInfo.ip_address}(${marker.nb_id})
BB State: ${stateInfo.bb_state}
Cell State: ${stateInfo.CELL1_STATE}
Core State: ${epcState}`
      ); highlightListNB(marker.nb_id, true, true);})
      .on('mouseout', () => {hideTooltip(); highlightListNB(marker.nb_id, false);})
      .setIcon(iconType ? (mouseHoveredNB.value === marker.nb_id ? highlightNBIcon : defaultNBIcon) : (mouseHoveredNB.value === marker.nb_id ? highlightGrayNBIcon : defaultGrayNBIcon))

      if (!filteredNB.value?.find(m => m.marker === newMarker))
      {
        newMarker.addTo(state.map);
        baseStationMarkers.value.push({
          marker: newMarker,
          id: marker.nb_id
        });
      }
    });
  }

  nbUEList.value = data.ue.filter(ue => ue.imsi && (ue.imsi.startsWith("00101000002") || ue.imsi.startsWith("001010000002")));
  cpeList.value = data.ue.filter(ue => ue.imsi && (ue.imsi.startsWith("00101000001") || ue.imsi.startsWith("001010000001")));
  if (cpeList.value) {
    filteredCPE.value?.filter(ue => ue.latitude && ue.longitude).forEach(marker => {
      const iconType = (marker.state !== "OFF");

      const newMarker = L.marker([marker.latitude, marker.longitude], { iconType: iconType })
      .on('click', () => {})
      .on('mouseover', (e) => {detectCustomMarkerUnderMouse(e, 
`5G CPE
IMSI: ${marker.imsi}
MSISDN: ${marker.msisdn}`
      ); highlightListCPE(marker.imsi, true, true);})
      .on('mouseout', () => {hideTooltip(); highlightListCPE(marker.imsi, false);})
      .setIcon(iconType ? (mouseHoveredCPE.value === marker.imsi ? highlightCPEIcon : defaultCPEIcon) : (mouseHoveredCPE.value === marker.imsi ? highlightGrayCPEIcon : defaultGrayCPEIcon))

      newMarker.addTo(state.map);
      CPEMarkers.value.push({
        marker: newMarker,
        id: marker.imsi
      })
    })
  }
}

const ICON_SIZE = [40, 40];
const ENB_SRC = new URL('../assets/images/simsys/pin_4gru.svg', import.meta.url).href;
// const GNB_SRC = new URL('../assets/images/simsys/pin_5gru.svg', import.meta.url).href;
const CPE_SRC = new URL('../assets/images/simsys/pin_5gcpe.svg', import.meta.url).href;

const createMarkerHtml = (className, src) => `
  <div class="${className}">
    <img src="${src}" style="width: ${ICON_SIZE[0]}px; height: ${ICON_SIZE[1]}px;" />
  </div>
`;
const createDivIcon = (className, src) => {
  return L.divIcon({
    html: createMarkerHtml(className, src),
    iconSize: ICON_SIZE,
    className: '', // 기본 스타일 제거
  })
}
const CLASS_NORMAL = 'origin-marker';
const CLASS_HIGHLIGHT = 'selected-origin-marker';
const CLASS_GRAY = 'grayscale-marker';
const CLASS_GRAY_HIGHLIGHT = 'selected-grayscale-marker';

const defaultNBIcon = createDivIcon(CLASS_NORMAL, ENB_SRC);
const highlightNBIcon = createDivIcon(CLASS_HIGHLIGHT, ENB_SRC);
const defaultGrayNBIcon = createDivIcon(CLASS_GRAY, ENB_SRC);
const highlightGrayNBIcon = createDivIcon(CLASS_GRAY_HIGHLIGHT, ENB_SRC);
export const highlightNB = (nb_id) => {
  if (!nb_id) return;
  if (mouseHoveredNB.value) resetNBHighlight(mouseHoveredNB.value);
  mouseHoveredNB.value = nb_id;

  const marker = baseStationMarkers.value.find(nb => nb.id === nb_id).marker;
  if (!marker) return;
  highlightListNB(nb_id, true);

  // zIndex 높여 마커 앞으로
  marker.setZIndexOffset(1300);
  marker.setIcon(marker.options.iconType ? highlightNBIcon : highlightGrayNBIcon);
};
export const resetNBHighlight = (nb_id) => {
  if (!nb_id) return;
  mouseHoveredNB.value = null;

  const marker = baseStationMarkers.value.find(nb => nb.id === nb_id).marker;
  if (!marker) return;
  highlightListNB(nb_id, false);
  
  // 원래 zIndex 복원
  marker.setZIndexOffset(0);
  marker.setIcon(marker.options.iconType ? defaultNBIcon : defaultGrayNBIcon);
};
const highlightListNB = (nb_id, highlight, direct = false) => {
  const listItem = document.querySelector(`#nb-${nb_id.replace(/\//g, '\\/')}`);
  if (listItem) {
    listItem.style.background = highlight ? '#C5C9CC' : '#FFFFFF';
    listItem.style.borderLeft = highlight ? '3px solid #97D4FF' : 'none';
    listItem.style.paddingLeft = highlight ? '4px' : '7px';
  }
  if (highlight && direct) {
    mouseHoveredNBMarker.value = nb_id;
  } else {
    mouseHoveredNBMarker.value = null;
  }
};
export const clickNBMarker = (nb_id) => {
  const marker = baseStationMarkers.value.find(nb => nb.id === nb_id).marker;
  state.map.setView(marker.getLatLng());
}

const defaultCPEIcon = createDivIcon(CLASS_NORMAL, CPE_SRC);
const highlightCPEIcon = createDivIcon(CLASS_HIGHLIGHT, CPE_SRC);
const defaultGrayCPEIcon = createDivIcon(CLASS_GRAY, CPE_SRC);
const highlightGrayCPEIcon = createDivIcon(CLASS_GRAY_HIGHLIGHT, CPE_SRC);
export const highlightCPE = (imsi) => {
  if (!imsi) return;
  if (mouseHoveredCPE.value) resetnbCPEHighlight(mouseHoveredCPE.value);
  mouseHoveredCPE.value = imsi;

  const marker = CPEMarkers.value.find(ue => ue.id === imsi).marker;
  if (!marker) return;
  highlightListCPE(imsi, true);

  // zIndex 높여 마커 앞으로
  marker.setZIndexOffset(1300);
  marker.setIcon(marker.options.iconType ? highlightCPEIcon : highlightGrayCPEIcon);
};
export const resetnbCPEHighlight = (imsi) => {
  if (!imsi) return;
  mouseHoveredCPE.value = null;

  const marker = CPEMarkers.value.find(ue => ue.id === imsi).marker;
  if (!marker) return;
  highlightListCPE(imsi, false);
  
  // 원래 zIndex 복원
  marker.setZIndexOffset(0);
  marker.setIcon(marker.options.iconType ? defaultCPEIcon : defaultGrayCPEIcon);
};
const highlightListCPE = (imsi, highlight, direct = false) => {
  const listItem = document.querySelector(`#ue-${imsi}`);
  if (listItem) {
    listItem.style.background = highlight ? '#C5C9CC' : '#FFFFFF';
    listItem.style.borderLeft = highlight ? '3px solid #97D4FF' : 'none';
    listItem.style.paddingLeft = highlight ? '4px' : '7px';
  }
  if (highlight && direct) {
    mouseHoveredCPEMarker.value = imsi;
  } else {
    mouseHoveredCPEMarker.value = null;
  }
};
export const clickCPEMarker = (imsi) => {
  const marker = CPEMarkers.value.find(ue => ue.id === imsi).marker;
  state.map.setView(marker.getLatLng());
}
export const mouseHoveredNB = ref(null);
export const mouseHoveredNBMarker = ref(null);

export const mouseHoveredCPE = ref(null);
export const mouseHoveredCPEMarker = ref(null);
//#endregion

//#region 영역 보여주기
export const showOneGF = (polygonData) => {
  if (selectedGeoFence.value) {
    let latlngList = [];
    polygonData.data.locations.forEach(loc => latlngList.push(L.latLng(loc.lat, loc.lng)))
    const type = polygonData.type
    if (type.includes("circle")) {
      const radius = type.substr(type.indexOf('#') + 1);
      // 원에 맞춰서 지도 보여주기
      const bounds = CalculateCircleBoundary(latlngList[0].lat, latlngList[0].lng, radius.value);
      state.map.fitBounds(bounds, { padding: [20, 20] }); // 약간의 여백 추가
    }
    else {
      state.map.fitBounds(latlngList);
    }
  }
};
//#endregion